import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const UNIFIED_API_PRERELEASE_VERSION = "2024-10-01-preview";
const getUnifiedApiVersion = () => EnvironmentService.useLatestUnifiedApiVersion() ? "2024-10-01-preview" : "2024-04-01-preview";
const UNIFIED_API_SEARCH_ISOLATIONGROUP_EXPAND = "Feature($expand=FeatureVariants($expand=Variant($select=IsolationGroups))),Feature($expand=FeatureVariants($expand=Variant($select=*))),Feature($select=*)";
const UNIFIED_API_SEARCH_ISOLATIONGROUP_FILTER = (searchString) => `Feature/FeatureVariants/Any(v: v/Variant/IsolationGroups/IsolationGroupSetEntries/any(i: i/Item/IsolationGroupId ${searchString}))`;
export {
  UNIFIED_API_PRERELEASE_VERSION,
  UNIFIED_API_SEARCH_ISOLATIONGROUP_EXPAND,
  UNIFIED_API_SEARCH_ISOLATIONGROUP_FILTER,
  getUnifiedApiVersion
};
//# sourceMappingURL=ExpAPIVUnified.constants.js.map
